import { render, staticRenderFns } from "./ClientTransactionEdit.vue?vue&type=template&id=8441b74e&scoped=true&"
import script from "./ClientTransactionEdit.vue?vue&type=script&lang=js&"
export * from "./ClientTransactionEdit.vue?vue&type=script&lang=js&"
import style0 from "./ClientTransactionEdit.vue?vue&type=style&index=0&id=8441b74e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8441b74e",
  null
  
)

export default component.exports